import { Badge } from '@karnov/kui-react'
import { FC, useCallback } from 'react'
import { Link } from 'react-router-dom'

import { DropdownMenuItem } from 'components/DropdownMenu'
import { FlowIcon } from 'components/FlowIcon'
import { useFeatureFlag } from 'hooks/useFeatureFlag'
import { useTriggerEvent } from 'hooks/useTriggerEvent'
import { getConfiguration } from 'services/config'
import { useTranslation } from 'services/i18n'
import { getUrlWithAppSource } from 'utils/getUrlWithAppSource'

export const GoToFlowMarketing: FC = () => {
  const { t } = useTranslation('translation', {
    keyPrefix: 'user_menu',
  })

  const hasFlowAccessFeatureFlag = useFeatureFlag('workspace_product')

  const { flowMarketingUrl } = getConfiguration()

  const triggerEvent = useTriggerEvent()

  const handleClick = useCallback(() => {
    triggerEvent({
      name: 'kai_workspace_entry_clicked',
      properties: {
        source: 'user_menu',
        has_access: hasFlowAccessFeatureFlag,
      },
    })
  }, [triggerEvent, hasFlowAccessFeatureFlag])

  const hasFlowMarketing = hasFlowAccessFeatureFlag || !flowMarketingUrl

  if (hasFlowMarketing) {
    return null
  }

  return (
    <Link
      to={getUrlWithAppSource({
        sourceType: 'kaila_user_menu',
        url: flowMarketingUrl,
      })}
      onClick={handleClick}
      target="_blank"
    >
      <DropdownMenuItem className="max-h-12">
        <span className="mr-2 inline-block w-4 -translate-y-0.5 self-start">
          <FlowIcon />
        </span>
        <div>
          <div className="flex flex-row gap-2">
            <div>{t('go_to_flow')}</div>
            <Badge variant="onboarding" isSmall>{t('badge')}</Badge>
          </div>
          <div className="truncate text-xs text-subdued">{t('learn_about_flow')}</div>
        </div>
      </DropdownMenuItem>
    </Link>
  )
}
